<template>
<div class="think-tank-claim-source-wrapper">
    <div class="columns-separator">
        <div class="col left-side-charts">
            <vertical-chart 
                class="chart-item"
                title="By Political Bent"
                sub-title="Where applicable as determined by arbiters independent from Real Clear Media"
                :data="polical_bent_data"
                />
        </div>

        <div class="col right-side-charts">
            <vertical-chart 
                class="chart-item"
                title="Top Fact-Checked Think Tanks"
                sub-title="Top 10 most fact-checked think tanks"
                :data="top_fact_checked_data"
                />
        </div>
    </div>
</div>
</template>

<script>

import VerticalChart from '../Charts/VerticalChart.vue';
import ClaimSourcesMixin from './ClaimSourcesMixin.js';

export default {
    name: '',
    components: {
        'vertical-chart': VerticalChart,
    },
    mixins: [
        ClaimSourcesMixin,
    ],
    data() {
        return {
            claim_method: 'claim_source_think_tank',
            polical_bent_data: [],
            top_fact_checked_data: [],
        };
    },
    created(){
        this.getClaimSourceData();
    },
    methods: {
        async getClaimSourceData(){
            let data = await this.getData({}, this.claim_method);
            console.log("CLAIM SOURCE", data);
            this.polical_bent_data      = data.data.data.political_bent_data;
            this.top_fact_checked_data  = data.data.data.top_fact_checked_source_data;
        },
    },
}
</script>

<style lang="scss">
.think-tank-claim-source-wrapper{
    .columns-separator{
        display: flex;
        justify-content: space-between;
        .col{
            flex-basis: 50%;
            .chart-item{
                
            }

            &.left-side-charts{
                margin-right: 10px;
                .chart-item{
                
                }
            }

            &.right-side-charts{
                margin-left: 10px;
                .chart-item{
                
                }
            }
        }
    }
}
</style>